<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>小猪银行配置</span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="概率配置" name="prob">

            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=>{return importUploadSuccess(res,'prob')}"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:pig:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>
              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:pig:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportProbData()"
                >导出</el-button>
              </el-col>
            </el-row>

            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData['prob']" :key="index">
                <el-form-item label="等级ID">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级ID" @change="(v)=>probLevelChange(v, index)" />
                </el-form-item>
                <el-form-item label="选择分组">
                  <el-select v-model="item.group" style="width: 150px" multiple placeholder="请选择">
                    <el-option
                      v-for="item in groups"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="一个体力瓶权重">
                  <el-input v-model.number="item.conf.weightOne" style="width: 100px;" placeholder="一个体力瓶权重" />
                </el-form-item>
                <el-form-item label="两个体力瓶权重">
                  <el-input v-model.number="item.conf.weightTwo" style="width: 100px;" placeholder="两个个体力瓶权重" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:pig:del']" type="danger" @click="delProb(item._id, item.levelId,index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:pig:add']" type="primary" @click="add('prob')">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:pig:add']" type="primary" @click="onSubmit('prob')">保存</el-button>
            </el-form>
            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables('prob')"
            />
          </el-tab-pane>
          <el-tab-pane label="购买配置" name="basic">
            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=>{return importUploadSuccess(res)}"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:pig:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>
              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:pig:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportBasicData()"
                >导出</el-button>
              </el-col>
            </el-row>
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData['basic']" :key="index">
                <el-form-item label="等级ID">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级ID" @change="(v)=>probLevelChange(v, index)" />
                </el-form-item>
                <el-form-item label="选择分组">
                  <el-select v-model="item.group" style="width: 150px" multiple placeholder="请选择">
                    <el-option
                      v-for="item in groups"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="等级范围">
                  <el-input v-model.number="item.startlv" style="width: 100px;" placeholder="开始等级" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="item.endlv" style="width: 100px;" placeholder="结束等级" />
                </el-form-item>
                <el-form-item>
                  <el-button type="text" style="margin-left: 16px;" @click="drawer[index][0].visible = true">
                    未购买状态
                  </el-button>
                  <el-drawer
                    title="未购买状态"
                    size="450px"
                    :visible.sync="drawer[index][0].visible"
                    direction="rtl"
                    :before-close="(d)=>{return handleClose(d, index, 0)}"
                  >
                    <el-form label-position="top" label-width="80px">
                      <el-form-item label="体力上限">
                        <el-input v-model.number="item.firstcfg.maxSpin" style="width: 400px" placeholder="体力上限" />
                      </el-form-item>
                      <el-form-item label="冷却时间">
                        <el-input v-model.number="item.firstcfg.coolDown" style="width: 400px" placeholder="冷却时间" />
                      </el-form-item>
                      <el-form-item label="价 格">
                        <el-select v-model="item.firstcfg.price" style="width: 400px" placeholder="请选择" @change="(v)=>{return priceChange(v, index,'firstcfg')}">
                          <el-option
                            v-for="item in prices"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </el-drawer>
                </el-form-item>
                <el-form-item>
                  <el-button type="text" style="margin-left: 16px;" @click="drawer[index][1].visible = true">
                    回购状态
                  </el-button>
                  <el-drawer
                    title="回购状态"
                    size="450px"
                    :visible.sync="drawer[index][1].visible"
                    direction="rtl"
                    :before-close="(d)=>{return handleClose(d, index, 1)}"
                  >
                    <el-form label-position="top" label-width="80px">
                      <el-form-item label="体力上限">
                        <el-input v-model.number="item.againcfg.maxSpin" style="width: 400px" placeholder="体力上限" />
                      </el-form-item>
                      <el-form-item label="冷却时间">
                        <el-input v-model.number="item.againcfg.coolDown" style="width: 400px" placeholder="冷却时间" />
                      </el-form-item>
                      <el-form-item label="价 格">
                        <el-select v-model="item.againcfg.price" style="width: 400px" placeholder="请选择">
                          <el-option
                            v-for="item in prices"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </el-drawer>
                </el-form-item>
                <el-form-item>
                  <el-button type="text" style="margin-left: 16px;" @click="drawer[index][2].visible = true">
                    回购N天状态
                  </el-button>
                  <el-drawer
                    title="回购N天状态"
                    :visible.sync="drawer[index][2].visible"
                    direction="rtl"
                    size="450px"
                    :before-close="(d)=>{return handleClose(d, index, 2)}"
                  >
                    <el-form label-position="top" label-width="80px">
                      <el-form-item label="体力上限">
                        <el-input v-model.number="item.longtimecfg.maxSpin" style="width: 400px" placeholder="体力上限" />
                      </el-form-item>
                      <el-form-item label="冷却时间">
                        <el-input v-model.number="item.longtimecfg.coolDown" style="width: 400px" placeholder="冷却时间" />
                      </el-form-item>
                      <el-form-item label="价 格">
                        <el-select v-model="item.longtimecfg.price" style="width: 400px" placeholder="请选择">
                          <el-option
                            v-for="item in prices"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </el-drawer>
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:pig:del']" type="danger" @click="delBasic(item._id, item.levelId, index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:pig:add']" type="primary" @click="add('basic')">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:pig:add']" type="primary" @click="onSubmit('basic')">保存</el-button>
            </el-form>

            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables('basic')"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  updateProbCfg,
  updateBasicCfg,
  getProbCfgList,
  getBasicCfgList,
  exportProb,
  exportBasic,
  importProb,
  importBasic,
  delPigProb, delPigBasic
} from '@/api/config/pig-cfg'
export default {
  name: 'PigConfig',
  data() {
    return {
      activeName: 'prob',
      drawer: [[{ visible: false }, { visible: false }, { visible: false }]],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      groups: [
        { label: '默认分组', value: 0 }
      ],
      prices: [
        { value: 0.99, sku: 'com.sa.dream_go.coins01' },
        { value: 1.99, sku: 'com.sa.dream_go.coins02' },
        { value: 9.99, sku: 'com.sa.dream_go.coins03' },
        { value: 19.99, sku: 'com.sa.dream_go.coins04' },
        { value: 29.99, sku: 'com.sa.dream_go.coins05' },
        { value: 49.99, sku: 'com.sa.dream_go.coins06' },
        { value: 99.99, sku: 'com.sa.dream_go.coins07' }
      ],
      formData:
        {
          'prob': [
            { _id: 0, 'levelId': 0, group: [], 'conf': { levelid: 0, weightOne: 0, weightTwo: 0, scoreOne: 0, scoreTwo: 0 }}
          ],
          'basic': [
            {
              _id: 0,
              levelId: 0,
              startlv: 0,
              endlv: 0,
              group: [],
              firstcfg: { maxSpin: 0, coolDown: 0, price: 0.99, sku: '' },
              againcfg: { maxSpin: 0, coolDown: 0, price: 0.99, sku: '' },
              longtimecfg: { maxSpin: 0, coolDown: 0, price: 0.99, sku: '' }
            }
          ]
        }
    }
  },
  created() {
    this.getTables('prob')
  },
  methods: {
    handleClose(done, index, i) {
      this.drawer[index][i].visible = false
    },
    probLevelChange(v, index) {
      this.formData['prob'][index].conf.levelid = v
    },
    onSubmit(name) {
      let data = ''
      if (name === 'prob') {
        data = JSON.stringify(this.formData['prob'])
        for (const i in this.formData['prob']) {
          const _data = this.formData['prob'][i]
          console.log('_data', _data)
          if (_data.levelId <= 0) {
            this.msgError('等级ID不能小于0')
            return
          }
          if (_data.group.length <= 0) {
            this.msgError('请选择分组')
            return
          }
        }
        console.log(data)
        updateProbCfg({ data: data }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(name)
          } else {
            this.msgError(res.msg)
          }
        })
      } else {
        data = JSON.stringify(this.formData['basic'])
        for (const i in this.formData['basic']) {
          const _data = this.formData['basic'][i]
          console.log('_data', _data)
          if (_data.levelId <= 0) {
            this.msgError('等级ID不能小于0')
            return
          }
          if (_data.group.length <= 0) {
            this.msgError('请选择分组')
            return
          }
          if (_data.startlv > _data.endlv) {
            this.msgError('最小等级不能大于最大等级')
            return
          }
        }
        updateBasicCfg({ data: data, name: name }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(name)
          } else {
            this.msgError(res.msg)
          }
        })
      }
    },
    getTables(tableName) {
      if (tableName === 'prob') {
        getProbCfgList(this.queryParams).then(res => {
          if (res.code === 200) {
            this.formData['prob'] = res.data.list
            res.data.list.forEach((item, index) => {
              this.formData['prob'][index]._id = 1
            })
            this.count = res.data.count
          } else {
            this.msgError(res.msg)
          }
        })
      } else {
        getBasicCfgList(this.queryParams).then(res => {
          if (res.code === 200) {
            this.formData['basic'] = res.data.list
            res.data.list.forEach((res, index) => {
              this.formData['basic'][index]._id = 1
              this.$set(this.drawer, index, [])
              for (let i = 0; i < 3; i++) {
                this.drawer[index].push({ visible: false })
              }
            })
            this.count = res.data.count
          } else {
            this.msgError(res.msg)
          }
        })
      }
    },
    add(name) {
      if (name === 'prob') {
        this.formData[name].push({ _id: 0, 'levelId': 0, 'conf': { levelid: 0, weightOne: 0, weightTwo: 0, scoreOne: 0, scoreTwo: 0 }})
      } else {
        const len = this.formData[name].length
        this.formData[name].push({
          _id: 0,
          levelId: 0,
          startlv: 0,
          endlv: 0,
          group: [],
          firstcfg: { maxSpin: 0, coolDown: 0, price: 0.99, sku: '' },
          againcfg: { maxSpin: 0, coolDown: 0, price: 0.99, sku: '' },
          longtimecfg: { maxSpin: 0, coolDown: 0, price: 0.99, sku: '' }
        })
        this.$set(this.drawer, len, [])
        for (let i = 0; i < 3; i++) {
          this.drawer[len].push({ visible: false })
        }
      }
    },
    delProb(_id, id, index) {
      if (_id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPigProb({ id: id }).then(res => {
            if (res.code === 200) {
              this.getTables('prob')
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData['prob'] = this.formData['prob'].filter((item, key) => {
          return index !== key
        })
      }
    },
    delBasic(_id, id, index) {
      if (_id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPigBasic({ id: id }).then(res => {
            if (res.code === 200) {
              this.getTables('basic')
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData['basic'] = this.formData['prob'].filter((item, key) => {
          return index !== key
        })
      }
    },
    exportProbData() {
      exportProb().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportBasicData() {
      exportBasic().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, tab) {
      if (tab === 'prob') {
        console.log(response)
        importProb({ data: response.data.path }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables('prob')
          } else {
            this.msgError(res.msg)
          }
        })
      } else {
        importBasic({ data: response.data.path }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables('basic')
          } else {
            this.msgError(res.msg)
          }
        })
      }
    },
    handleClick(tab, event) {
      const tableName = tab.name
      this.getTables(tableName)
    },
    priceChange(v, index, key) {
      let sku = ''
      this.prices.forEach((item, i) => {
        console.log(item.value === v)
        if (item.value === v) {
          sku = item.sku
        }
      })
      this.formData['basic'][index][key].sku = sku
      console.log(this.formData['basic'][index][key])
    }
  }
}
</script>

<style scoped>
</style>
